import { render, staticRenderFns } from "./ReviewManagement.vue?vue&type=template&id=7e4f67f6&scoped=true"
import script from "./ReviewManagement.vue?vue&type=script&lang=js"
export * from "./ReviewManagement.vue?vue&type=script&lang=js"
import style0 from "./ReviewManagement.vue?vue&type=style&index=0&id=7e4f67f6&prod&lang=css"
import style1 from "./ReviewManagement.vue?vue&type=style&index=1&id=7e4f67f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4f67f6",
  null
  
)

export default component.exports